module.exports = __webpack_public_path__ + "media/scene_15.0ccdbf49.mp3";